<template>
    <main class="flex-1 relative pb-8 z-0 overflow-y-auto">
        <PageHeader>
            <h1 class="ml-3 text-2xl font-bold text-gray-900 sm:truncate flex flex-row justify-between w-full">
                <span>
                    <span class="flex flex-row">
                        <Loader v-if="isToursFetchPending"
                                class="-sm m-2"/>
                        <template v-else>
                            Tours
                        </template>
                    </span>
                    <LangSwitcher />
                </span>
                <span>
                    <a href="#" @click.prevent="handleCreateTour"
                       class="flex items-center px-4 py-1 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-custom-600 hover:bg-custom-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
                        Créer un tour
                    </a>
                </span>
            </h1>
        </PageHeader>

        <div class="mt-8 lg:max-w-6xl lg:mx-auto">
            <div class="m-4">
                <Search
                    v-model="search"
                    @update:modelValue="handleSearchChange"
                />

                <List
                    :items="tours"
                    :columns="columns"
                    :desc="desc"
                    @sortBy="handleSortBy"
                    @editItem="handleEditTour"
                    @deleteItem="handleDeleteTour"
                    editable
                    deletable
                />

                <Pagination
                    v-if="lastPage > 1"
                    :current_project="currentPage"
                    :last_page="lastPage"
                    @change="handleChangePage"
                />
            </div>
        </div>
    </main>
</template>

<script>
import PageHeader from "../../components/partials/page-header";
import Loader from "../../components/partials/loader";
import LangSwitcher from "../../components/partials/lang-switcher";
import List from "../../components/partials/list"
import Pagination from "../../components/partials/pagination"
import Search from "../../components/partials/search"

export default {
    beforeMount() {
        if (!this.domain || this.domain.id !== this.$route.params.domain_id) {
            this.$store.dispatch('domains/getSingle', {id: this.$route.params.domain_id, includes: ['projects', 'settings', 'files', 'videos', 'videos.formats', 'videos.thumb', 'tours', 'tours.thumb']})
        }
    },
    data() {
        return {
            search: null,
            desc: false
        }
    },
    computed: {
        isToursFetchPending() {
            return this.$store.state.tours.isFetchListPending;
        },
        domain() {
            return this.$store.state.domains.single;
        },
        tours() {
            return this.domain && this.domain.tours ? this.domain.tours.data : [];
        },
        locale() {
            return this.$store.state.config.locale;
        },
        columns() {
            return {
                id: {},
                ['translatable.name.'+this.locale]: {
                    label: 'Nom'
                },
                ['thumb.url']: {
                    filter: 'image',
                    label: 'Image'
                }
            }
        },
        lastPage() {
            return this.$store.state.tours.pagination.last_page
        },
        currentPage() {
            return this.$store.state.tours.pagination.current_page
        },
    },
    methods: {
        handleChangePage(page = this.currentPage) {
            this.$store.dispatch('tours/getList', {
                'page': page,
                'sort_by': this.sort_by,
                'desc': this.desc,
                'search': this.search ? {'email': this.search} : {}
            });
        },
        handleSortBy(type) {
            this.desc = !this.desc;
            this.sort_by = type;

            this.handleChangePage();
        },
        handleSearchChange(search) {
            this.search = search;
            this.handleChangePage();
        },
        handleCreateTour() {
            this.$store.dispatch('tours/resetSingle')
            this.$store.dispatch('modals/open', 'tour-save');
        },
        handleEditTour(tour) {
            this.$store.dispatch('tours/setSingle', tour);
            this.$store.dispatch('modals/open', 'tour-save');
        },
        handleDeleteTour(tour) {
            this.$store.state.tours.single = tour;
            this.$store.dispatch('modals/open', 'tour-delete');
        },
    },
    components: {
        PageHeader,
        Loader,
        LangSwitcher,
        Search,
        List,
        Pagination
    }
}
</script>
